import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SimulacaoFinanciamentoRequest,
  SimulacaoFinanciamentoResponse
} from '../models/simulacao-financiamento.model';

export abstract class SimulacaoFinanciamentoRepository {
  abstract consultarMargens(request: SimulacaoFinanciamentoRequest): Observable<SimulacaoFinanciamentoResponse>;
  abstract simular(request: SimulacaoFinanciamentoRequest): Observable<SimulacaoFinanciamentoResponse>;
}

export const SIMULACAO_FINANCIAMENTO_REPOSITORY = new InjectionToken<SimulacaoFinanciamentoRepository>(
  'SIMULACAO_FINANCIAMENTO_REPOSITORY'
);
